import * as React from "react";
import IAlertMessageProps from "./IAlertMessage";
import "../../../assets/sass/widgets/alertMessage.scss";
import { imagePathurl } from "../../utils/utils";
import AppTracking from "../../AppTracking";
import ConstantFile from "../../constants/constantFile";
/**
 * @class AlertMessage
 * @param {string} type - Alert Type - either danger / success
 * @param {string} message - Alert Message
 * @param {function} closeAlert - callback function to close alert
 * @description
 * This is an alert bar that comes up on error response or API failure or any bad response during any service call.
 * @category Widgets
 */
const AlertMessage: React.FC<IAlertMessageProps> = ({ type, message, closeAlert }) => {
    //image CDN_PATH
    const getimagePath = imagePathurl();
    setTimeout(() => {
        closeAlert();
    }, ConstantFile.autoHideToasts);
    const multipleMsgs = message ? message.split("|") : [];
    return (
        <div className={"alert-box " + type}>
            <div>
                {type == "error" ? (
                    <img
                        id="warningIcon"
                        className="warning-icon"
                        src={`${getimagePath}alert-white.png`}
                        alt="warning icon"
                    />
                ) : (
                    <img id="warningIcon" className="success-icon" src={`${getimagePath}tick.png`} alt="warning icon" />
                )}
            </div>
            <div className="message pl7">
                {multipleMsgs.map((message, index) => (
                    <div key={`message-${index}`}>{message}</div>
                ))}
            </div>
            <div
                tabIndex={40}
                className="close-icon"
                onClick={closeAlert}
                onKeyDown={(e) => {
                    if (e.keyCode === 13) closeAlert();
                }}
            >
                <img id="closeIcon" src={`${getimagePath}menu-close-mini.png`} alt="close icon" className="icon" />
            </div>
            {type == "error" ? <div className="alert-tracking-id">{`Tracking Id: ${AppTracking.id}`}</div> : <></>}
        </div>
    );
};

export default AlertMessage;
